export default "/_next/static/chunks/fonts/GraphikLightItalic-28a3ee4904f00f7f06013fc6175866be.otf";